/**
 * Blocks manual-bundle parent products (Gift Set shells) from being added to cart,
 * and removes them if they are already present.
 * Depends on window.__TB_BLOCKED_BUNDLE_PARENT_VARIANTS (array of variant ids).
 */
(function () {
  var blocked = window.__TB_BLOCKED_BUNDLE_PARENT_VARIANTS;
  if (!blocked || !blocked.length) return;

  var blockedSet = {};
  for (var i = 0; i < blocked.length; i++) {
    blockedSet[String(blocked[i])] = true;
  }

  function isBlockedVariantId(id) {
    return !!blockedSet[String(id)];
  }

  function isCartAddUrl(url) {
    if (!url) return false;
    var s = String(url);
    return s.indexOf('/cart/add') !== -1;
  }

  function filterItems(items) {
    if (!items || !items.length) return [];
    var out = [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var id = item && (item.id != null ? item.id : item.variant_id);
      if (!isBlockedVariantId(id)) out.push(item);
    }
    return out;
  }

  function parseBody(body) {
    if (body == null || body === '') return null;
    if (typeof body === 'string') {
      try {
        return JSON.parse(body);
      } catch (e) {
        return null;
      }
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var id = body.get('id') || body.get('items[0][id]');
      if (id) return { id: id, quantity: body.get('quantity') || 1, __formData: body };
      return null;
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      var vid = body.get('id');
      if (vid) return { id: vid, quantity: body.get('quantity') || 1 };
      return null;
    }
    if (typeof body === 'object') return body;
    return null;
  }

  function rewriteAddPayload(payload) {
    if (!payload) return { payload: payload, blockedAll: false, changed: false };

    if (payload.items && Array.isArray(payload.items)) {
      var filtered = filterItems(payload.items);
      var changed = filtered.length !== payload.items.length;
      return {
        payload: Object.assign({}, payload, { items: filtered }),
        blockedAll: changed && filtered.length === 0,
        changed: changed,
      };
    }

    if (payload.id != null && isBlockedVariantId(payload.id)) {
      return { payload: payload, blockedAll: true, changed: true };
    }

    return { payload: payload, blockedAll: false, changed: false };
  }

  function emptyAddResponse() {
    return new Response(JSON.stringify({ items: [], message: 'Bundle parent product cannot be added to cart' }), {
      status: 422,
      statusText: 'Unprocessable Entity',
      headers: { 'Content-Type': 'application/json' },
    });
  }

  function serializePayload(originalBody, payload) {
    if (typeof originalBody === 'string' || originalBody == null) {
      return JSON.stringify(payload);
    }
    if (typeof FormData !== 'undefined' && originalBody instanceof FormData) {
      return JSON.stringify(payload);
    }
    return JSON.stringify(payload);
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var method = (init && init.method) || (input && input.method) || 'GET';
      if (!isCartAddUrl(url) || String(method).toUpperCase() !== 'POST') {
        return nativeFetch.apply(this, arguments);
      }

      var body = init && init.body;
      if (!body && input && typeof input === 'object' && input.clone) {
        return nativeFetch.apply(this, arguments);
      }

      var parsed = parseBody(body);
      var result = rewriteAddPayload(parsed);

      if (result.blockedAll) {
        if (window.tbRemoveBlockedBundleParents) window.tbRemoveBlockedBundleParents();
        return Promise.resolve(emptyAddResponse());
      }

      if (result.changed) {
        var nextInit = Object.assign({}, init || {}, {
          body: serializePayload(body, result.payload),
          headers: Object.assign({}, (init && init.headers) || {}, {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          }),
        });
        return nativeFetch.call(this, url, nextInit);
      }

      return nativeFetch.apply(this, arguments);
    };
  }

  var XHR = window.XMLHttpRequest;
  if (XHR && XHR.prototype) {
    var open = XHR.prototype.open;
    var send = XHR.prototype.send;
    XHR.prototype.open = function (method, url) {
      this.__tbCartAdd = String(method || '').toUpperCase() === 'POST' && isCartAddUrl(url);
      this.__tbCartAddUrl = url;
      return open.apply(this, arguments);
    };
    XHR.prototype.send = function (body) {
      if (!this.__tbCartAdd) return send.apply(this, arguments);

      var parsed = parseBody(body);
      var result = rewriteAddPayload(parsed);

      if (result.blockedAll) {
        var xhr = this;
        setTimeout(function () {
          Object.defineProperty(xhr, 'status', { configurable: true, get: function () { return 422; } });
          Object.defineProperty(xhr, 'readyState', { configurable: true, get: function () { return 4; } });
          Object.defineProperty(xhr, 'responseText', {
            configurable: true,
            get: function () {
              return JSON.stringify({ items: [], message: 'Bundle parent product cannot be added to cart' });
            },
          });
          if (typeof xhr.onreadystatechange === 'function') xhr.onreadystatechange();
          if (typeof xhr.onload === 'function') xhr.onload();
        }, 0);
        if (window.tbRemoveBlockedBundleParents) window.tbRemoveBlockedBundleParents();
        return;
      }

      if (result.changed) {
        return send.call(this, serializePayload(body, result.payload));
      }

      return send.apply(this, arguments);
    };
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;

      var idInput = form.querySelector('[name="id"]');
      var id = idInput && idInput.value;
      if (id && isBlockedVariantId(id)) {
        event.preventDefault();
        event.stopPropagation();
        if (window.tbRemoveBlockedBundleParents) window.tbRemoveBlockedBundleParents();
      }
    },
    true
  );

  var scrubbing = false;
  window.tbRemoveBlockedBundleParents = async function tbRemoveBlockedBundleParents() {
    if (scrubbing) return false;
    scrubbing = true;
    var removed = false;
    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var cart = await nativeFetch.call(window, root + 'cart.js').then(function (r) {
        return r.json();
      });
      if (!cart || !cart.items || !cart.items.length) return false;

      var updates = {};
      for (var i = 0; i < cart.items.length; i++) {
        var line = cart.items[i];
        if (isBlockedVariantId(line.variant_id) || isBlockedVariantId(line.id)) {
          updates[String(line.variant_id || line.id)] = 0;
          removed = true;
        }
      }

      if (!removed) return false;

      await nativeFetch.call(window, root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      });

      if (typeof window.acUpdateContent === 'function') {
        try {
          await window.acUpdateContent();
        } catch (e) {}
      }

      return true;
    } catch (e) {
      return false;
    } finally {
      scrubbing = false;
    }
  };

  function runScrub() {
    window.tbRemoveBlockedBundleParents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runScrub);
  } else {
    runScrub();
  }
})();
